import { EntityTypes } from '../entity';
import { DocumentEditMode } from '../userSetting';
import { AITaskSessionApproval } from './aiTaskSession';
import { CopilotPanelContentBase, CopilotPanelContext } from './copilotBridge';
import { CopilotConversation } from './copilotConversation';

export class CopilotGenericContent extends CopilotPanelContentBase {
  public readonly context = CopilotPanelContext.Generic;

  sessionId?: number;

  contextKey?: string;

  entityType?: EntityTypes;

  entityId?: number;

  conversation: CopilotConversation;

  approvals: AITaskSessionApproval[];

  selectedDocument?: CopilotSelectedDocument;

  // Reference to the tenant-authored library instruction whose compiled plan should run. The backend
  // resolves the executable plan from the database; the client never sends the plan itself.
  compiledPlanExternalId?: string;

  constructor() {
    super();

    this.conversation = new CopilotConversation();
    this.approvals = [];
  }
}

export class CopilotSelectedDocument {
  contentBlockId?: string;

  version?: number;

  title?: string;

  isDocumentEditorSession?: boolean;

  // How the agent should apply its edits: 'tracked' records them as tracked changes, 'direct' applies them
  // immediately. Sourced from the user's documentEditModeAI setting so the backend can steer the agent.
  documentEditMode?: DocumentEditMode;

  // The user's current text selection in the document, so the agent can ground "change this" on the exact
  // highlight. Undefined when nothing is selected. Anchors are best-effort (SuperDoc: SelectionTarget
  // blockId+offset; Eigenpal: none) and supplementary to the text.
  selectionText?: string;

  selectionStartBlockId?: string;

  selectionStartOffset?: number;

  selectionEndBlockId?: string;

  selectionEndOffset?: number;
}
